import buildScreenHeaderItems from '@/components/buildScreenHeaderItems'
import EmptyStateIllustration from '@/components/EmptyStateIllustration'
import { Center } from '@/components/ui/center'
import { Spinner } from '@/components/ui/spinner'
import useWebBackButton from '@/lib/hooks/useWebBackButton'
import SwitchMerchant from '@/modules/trade/SwitchMerchant'
import {
  restoreTradeMerchantType,
  selectAvailableMerchantTypes,
  selectCanAccessTrade,
  selectTradeMerchantType,
} from '@/redux/slices/tradeSlice'
import { useAppDispatch, useAppSelector } from '@/redux/store'
import { Stack, useRouter } from 'expo-router'
import { useEffect } from 'react'

export default function SwitchMerchantPage() {
  const dispatch = useAppDispatch()
  const router = useRouter()
  const headerLeftItems = useWebBackButton('/trade')

  const billingAccount = useAppSelector(state => state.currentUser.user?.billingAccount)
  const currentUserLoaded = useAppSelector(state => state.currentUser.loaded)
  const canAccessTrade = useAppSelector(selectCanAccessTrade)
  const availableMerchantTypes = useAppSelector(selectAvailableMerchantTypes)
  const merchantType = useAppSelector(selectTradeMerchantType)
  const merchantTypeRestored = useAppSelector(state => state.trade.merchantTypeRestored)

  useEffect(() => {
    if (!merchantTypeRestored) dispatch(restoreTradeMerchantType())
  }, [dispatch, merchantTypeRestored, billingAccount?.id])

  const header = <Stack.Screen options={{ ...buildScreenHeaderItems({ left: headerLeftItems }) }} />

  if (!currentUserLoaded) {
    return (
      <>
        {header}
        <Center className="flex-1">
          <Spinner />
        </Center>
      </>
    )
  }

  if (!canAccessTrade || !billingAccount || !merchantType) {
    return (
      <>
        {header}
        <Center className="flex-1">
          <EmptyStateIllustration message="你没有查看交易的权限" />
        </Center>
      </>
    )
  }

  const handleSwitched = () => {
    if (router.canGoBack()) router.back()
    else router.replace('/trade')
  }

  return (
    <>
      {header}
      <SwitchMerchant
        billingAccount={billingAccount}
        merchantType={merchantType}
        availableMerchantTypes={availableMerchantTypes}
        onSwitched={handleSwitched}
      />
    </>
  )
}
